module.exports = "../../../../platform/assets/pageMainIcon/industry_.svg";